import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-references-section',
  templateUrl: './references-section.component.html',
  styleUrls: ['./references-section.component.scss']
})
export class ReferencesSectionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
